import { defaultThemeV2 } from "../../../../theme/defaultThemeV2";
import HlsVideoPlayer from "./HlsVideoPlayer";
import { CSSProperties } from "react";

const VideoPlayers = (
  videoUrl: string,
  style: CSSProperties,
  copy = defaultThemeV2.copy,
) => {
  const isM3u8 = videoUrl?.includes(".m3u8");
  const getVdoCipherEmbedProps = () => {
    try {
      const parsedUrl = new URL(videoUrl);
      if (!parsedUrl.hostname.includes("player.vdocipher.com")) return null;
      const otp = parsedUrl.searchParams.get("otp");
      const playbackInfo = parsedUrl.searchParams.get("playbackInfo");
      /* c8 ignore next 1 */
      if (!otp || !playbackInfo) return null;
      return {
        otp,
        playbackInfo,
        player: parsedUrl.searchParams.get("player"),
      };
      /* c8 ignore next 3 */
    } catch {
      return null;
    }
  };
  const vdoCipherProps = getVdoCipherEmbedProps();

  if (isM3u8) {
    return <HlsVideoPlayer src={videoUrl} style={style} copy={copy} />;
  } else if (vdoCipherProps) {
    const iframeSrc = new URL("https://player.vdocipher.com/v2/");
    iframeSrc.searchParams.set("otp", vdoCipherProps.otp);
    iframeSrc.searchParams.set("playbackInfo", vdoCipherProps.playbackInfo);
    /* c8 ignore next 1 */
    if (vdoCipherProps.player) {
      iframeSrc.searchParams.set("player", vdoCipherProps.player);
    }

    return (
      <iframe
        data-testid="video-container"
        src={iframeSrc.toString()}
        style={style}
        allow="encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        title={copy.labels.cipherPlayer}
      />
    );
  }

  return null;
};

export default VideoPlayers;
